module.exports = __webpack_public_path__ + "static/media/reactma3.b4752cef.svg";